export interface FilterOption {
  id: string;
  name: string;
}

// undefined = no filter; while options load, saved ids pass through (station stays filtered)
export function pruneSelection(
  saved: string[] | undefined,
  optionIds: string[] | undefined,
): string[] | undefined {
  if (!saved || saved.length === 0) return undefined;
  if (!optionIds) return saved;
  const live = saved.filter(id => optionIds.includes(id));
  if (live.length === 0) return undefined;
  return live.length === saved.length ? saved : live;
}

export function toggleSelection(current: string[], id: string): string[] {
  return current.includes(id)
    ? current.filter(x => x !== id)
    : [...current, id];
}

export interface SummaryLabels {
  all: string;
  count: (selected: number, total: number) => string;
}

export function summariseSelection(
  options: FilterOption[],
  selectedIds: string[],
  labels: SummaryLabels,
): string {
  if (options.length === 0) return '';
  const selected = options.filter(option => selectedIds.includes(option.id));
  if (selected.length === 0) return labels.all;
  if (selected.length <= 2) return selected.map(o => o.name).join(', ');
  return labels.count(selected.length, options.length);
}
